import styles from './SearchResults.module.scss';
import {isEmpty, map, slice} from "lodash";
import Link from "next/link";

const CategoriesSkeleton = () => (
    <>
      <h5 className="h-6 bg-white/40 rounded-full w-48"></h5>
      <ul className="mt-6">
        <li className="h-2 bg-white/40 rounded-full w-48 mb-4"/>
        <li className="h-2 bg-white/40 rounded-full w-48 mb-4"/>
        <li className="h-2 bg-white/40 rounded-full w-48 mb-4"/>
        <li className="h-2 bg-white/40 rounded-full w-48 mb-4"/>
        <li className="h-2 bg-white/40 rounded-full w-48 mb-4"/>
      </ul>
    </>
)

const ProductCardSkeleton = () => (
    <div role="status" className={`${styles.productCard} w-1/2 space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center`}>
      <div className="w-full h-48 bg-white/40 rounded"></div>
      <div className="w-full">
        <div className="h-2.5 bg-white/40 rounded-full w-48 mb-4"></div>
        <div className="h-2 bg-white/40 rounded-full max-w-[480px] mb-2.5"></div>
        <div className="h-2 bg-white/40 rounded-full mb-2.5"></div>
        <div className="h-2 bg-white/40 rounded-full max-w-[440px] mb-2.5"></div>
        <div className="h-2 bg-white/40 rounded-full max-w-[460px] mb-2.5"></div>
        <div className="h-2 bg-white/40 rounded-full max-w-[360px]"></div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
)

const MainProductCardSkeleton = () => (
    <div role="status" className={`max-w-full w-full space-y-8 animate-pulse md:space-y-0 md:items-center`}>
        <div className="w-full mb-8 h-48 bg-white/40 rounded"></div>
        <div className="w-full">
            <div className="h-2.5 bg-white/40 rounded-full dark:bg-white/40 w-48 mb-4"></div>
            <div className="h-2 bg-white/40 rounded-full max-w-[480px] mb-2.5"></div>
            <div className="h-2 bg-white/40 rounded-full mb-2.5"></div>
            <div className="h-2 bg-white/40 rounded-full max-w-[440px] mb-2.5"></div>
            <div className="h-2 bg-white/40 rounded-full max-w-[460px] mb-2.5"></div>
            <div className="h-2 bg-white/40 rounded-full max-w-[360px]"></div>
        </div>
        <span className="sr-only">Loading...</span>
    </div>
)

const SearchResultsSkeleton = () => {
  return (
      <div className={styles.results}>
        <div className={styles.left}>
            <CategoriesSkeleton />
        </div>
        <div className={styles.right}>
          <div className={styles.mainProduct}>
            <MainProductCardSkeleton />
          </div>
          <div className={styles.products}>
            <div className={styles.wrapper}>
              <ProductCardSkeleton />
              <ProductCardSkeleton />
            </div>
          </div>
        </div>
      </div>

      // <div>
      //   <section className="placeholder-glow">
      //     <div className={styles.skeletonCard}>
  //       <div className={styles.skeletonImg}>
  //         <span className="placeholder w-100 h-100"></span>
  //       </div>
  //       <h3 className="placeholder col-10 mt-3 mb-4"></h3>
  //       <p className="placeholder col-12 mb-2"></p>
  //       <p className="placeholder col-12 mb-2"></p>
  //       <div className="d-flex justify-content-between mt-4">
  //         <span className="placeholder col-4"></span>
  //         <span className="placeholder col-4"></span>
  //       </div>
  //     </div>
  //
  //     <div className={styles.wrapper}>
  //       <div className={styles.skeletonCard}>
  //         <div className={styles.skeletonImg}>
  //           <span className="placeholder w-100 h-100"></span>
  //         </div>
  //         <h3 className="placeholder col-10 mt-3 mb-4"></h3>
  //         <p className="placeholder col-12 mb-2"></p>
  //         <p className="placeholder col-12 mb-2"></p>
  //         <div className="d-flex justify-content-between mt-4">
  //           <span className="placeholder col-4"></span>
  //           <span className="placeholder col-4"></span>
  //         </div>
  //       </div>
  //       <div className={styles.skeletonCard}>
  //         <div className={styles.skeletonImg}>
  //           <span className="placeholder w-100 h-100"></span>
  //           </div>
  //           <h3 className="placeholder col-10 mt-3 mb-4"></h3>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <div className="d-flex justify-content-between mt-4">
  //             <span className="placeholder col-4"></span>
  //             <span className="placeholder col-4"></span>
  //           </div>
  //         </div>
  //         <div className={styles.skeletonCard}>
  //           <div className={styles.skeletonImg}>
  //             <span className="placeholder w-100 h-100"></span>
  //           </div>
  //           <h3 className="placeholder col-10 mt-3 mb-4"></h3>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <div className="d-flex justify-content-between mt-4">
  //             <span className="placeholder col-4"></span>
  //             <span className="placeholder col-4"></span>
  //           </div>
  //         </div>
  //         <div className={styles.skeletonCard}>
  //           <div className={styles.skeletonImg}>
  //             <span className="placeholder w-100 h-100"></span>
  //           </div>
  //           <h3 className="placeholder col-10 mt-3 mb-4"></h3>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <p className="placeholder col-12 mb-2"></p>
  //           <div className="d-flex justify-content-between mt-4">
  //             <span className="placeholder col-4"></span>
  //             <span className="placeholder col-4"></span>
  //           </div>
  //         </div>
  //       </div>
  //     </section>
  //   </div>
  );
};
export default SearchResultsSkeleton;
